import React from 'react';
import ButtonIcon from '../ButtonIcon';
import { IconColors, IconSizes, IconVariants } from '../../constants';
import CommentIcon from '../../assets/icons/comment.svg';
import './ButtonComment.scss';
const ButtonComment = ({ size = IconSizes.Medium, hasMarker = false, disabled = false, clickHandle = () => null, }) => {
    return (<div className="ml-btn-comment">
      <ButtonIcon size={size} variant={IconVariants.Plain} color={IconColors.Primary} disabled={disabled} clickHandle={clickHandle}>
        <CommentIcon />
      </ButtonIcon>
      {hasMarker
            ? <div className="ml-btn-comment__marker"/>
            : null}
    </div>);
};
export default ButtonComment;
